function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0_add{fill:#FDB614;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0_add",
  d: "M35.5,6.1C27.4-2,14.2-2,6.1,6.1s-8.1,21.3,0,29.4s21.3,8.1,29.4,0S43.6,14.2,35.5,6.1L35.5,6.1z M32.2,20.7 c0,0.8-0.7,1.6-1.6,1.6h-8.3l0,8.8c0,0.8-0.7,1.6-1.6,1.6c-0.8,0-1.6-0.7-1.6-1.6v-8.8h-8.3c-0.8,0-1.6-0.7-1.6-1.6 c0-0.8,0.7-1.6,1.6-1.6H19v-8.1c0-0.8,0.7-1.6,1.6-1.6c0.9-0.1,1.6,0.7,1.6,1.6l0,8.1h8.3C31.5,19.2,32.2,19.9,32.2,20.7L32.2,20.7z "
});

var SvgAddagain = function SvgAddagain(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "41.6px",
    height: "41.6px",
    viewBox: "0 0 41.6 41.6",
    style: {
      enableBackground: "new 0 0 41.6 41.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddagain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addagain.03f5fb07.svg";
export { ForwardRef as ReactComponent };